import {ArchiveIcon, GitPullRequestClosedIcon, GitPullRequestIcon, TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'
import {useState} from 'react'

import type {RepoPullsBulkUpdate} from '../helpers/repo-pulls-bulk-update'

const BULK_STATE_OPTIONS = [
  {label: 'Open', update: {state: 'open'}, icon: GitPullRequestIcon, colorClass: 'fgColor-open'},
  {label: 'Closed', update: {state: 'closed'}, icon: GitPullRequestClosedIcon, colorClass: 'fgColor-closed'},
] as const

const BULK_ARCHIVE_OPTIONS = [
  {label: 'Archived', update: {archive: 'true'}, icon: ArchiveIcon},
  {label: 'Unarchived', update: {archive: 'false'}, icon: ArchiveIcon},
] as const

interface RepoPullsBulkMarkAsProps {
  canArchive: boolean
  disabled: boolean
  nested: boolean
  onUpdate: (update: RepoPullsBulkUpdate) => void
}

export function RepoPullsBulkMarkAs({canArchive, disabled, nested, onUpdate}: RepoPullsBulkMarkAsProps) {
  const [isOpen, setIsOpen] = useState(false)

  const options = canArchive ? [...BULK_STATE_OPTIONS, ...BULK_ARCHIVE_OPTIONS] : BULK_STATE_OPTIONS
  const items = options.map(option => (
    <ActionList.Item
      key={option.label}
      aria-disabled={disabled || undefined}
      onSelect={() => {
        if (disabled) return
        onUpdate(option.update)
        setIsOpen(false)
      }}
    >
      <ActionList.LeadingVisual>
        <option.icon className={'colorClass' in option ? option.colorClass : undefined} />
      </ActionList.LeadingVisual>
      {option.label}
    </ActionList.Item>
  ))

  if (nested) {
    return (
      <ActionMenu open={isOpen} onOpenChange={open => !disabled && setIsOpen(open)}>
        <ActionMenu.Anchor>
          <ActionList.Item aria-disabled={disabled || undefined}>
            <ActionList.LeadingVisual>
              <GitPullRequestClosedIcon />
            </ActionList.LeadingVisual>
            Mark as
          </ActionList.Item>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay>
          <ActionList>{items}</ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    )
  }

  return (
    <ActionMenu open={isOpen} onOpenChange={open => !disabled && setIsOpen(open)}>
      <ActionMenu.Anchor>
        <Button
          aria-disabled={disabled || undefined}
          leadingVisual={GitPullRequestClosedIcon}
          trailingVisual={TriangleDownIcon}
        >
          Mark as
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>{items}</ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
